import React from "react";
import styled from "styled-components";
import theme from "../../../styles/theme";
import headingStyles from "./headingStyles";

const {
	colors,
	font,
	breakPoints: { screenQuery },
} = theme;

export const style = (props) => `
  margin-bottom: 10px;
  font-family: ${font.recoleta};

  font-size: 28px;
  line-height: 30px;
  ${screenQuery.large}{
    font-size: 26px;
    line-height: 28px;
  }
  ${screenQuery.medium}{
    margin-bottom: 8px;
  }
  ${screenQuery.small}{
    font-size: 24px;
    line-height: 26px;
  }
`;

const H3 = styled.h3(headingStyles, (props) => style(props));
export default ({ children, ...props }) => <H3 {...props}>{children}</H3>;
